import React, { useState } from "react";
import PropTypes from "prop-types";

import { addMember, removeMember } from "domain/Groups/api";
import { removeMember as excludeFromBlackList } from "domain/BlackLists/api";
import { find } from "lodash-es";
import TagList from "ui/TagList";
import AddToBlackListModal from "components/PlayersReport/AddToBlackListModal/Component";
import Tag from "ui/Tag";
import Tooltip from "ui/Tooltip";

// Зачем такая сложная логика с группами и черными списками, спросишь ты меня , о читатель
// а хз - отвечу я. Дорогие бэкендеры между собой так решили, ни с кем не посоветовавшись
const PlayerReportTags = ({
    id,
    isOrganizer,
    userGroups,
    blacklists,
    updateGroupData,
    updateBlackList,
    player,
}) => {
    const [selectedBlacklist, setSelectedBlacklist] = useState(null);
    if (!isOrganizer) {
        return null;
    }

    const closeModal = () => {
        setSelectedBlacklist(null);
    };

    const add = async ({ value: groupId, isBlackList }) => {
        if (isBlackList) {
            setSelectedBlacklist(groupId);
            return null;
        }

        const result = await addMember(groupId, id);
        updateGroupData(groupId, result);
    };

    const exclude = async ({ value: groupId, isBlackList }) => {
        const exclude = isBlackList ? excludeFromBlackList : removeMember;
        const updateCollection = isBlackList
            ? updateBlackList
            : updateGroupData;

        const result = await exclude(groupId, id);
        updateCollection(groupId, result);
    };

    const [appliedGroups, availableGroups] = prepareGroups(userGroups, id);
    const [appliedBlackLists, availableBlackList] = prepareGroups(
        blacklists,
        id,
        true
    );

    return (
        <div className="report__item-tags">
            {!!selectedBlacklist && (
                <AddToBlackListModal
                    groupId={selectedBlacklist}
                    player={player}
                    updateBlackList={updateBlackList}
                    onClose={closeModal}
                />
            )}
            <TagList
                items={[...appliedGroups, ...appliedBlackLists]}
                availableTags={[...availableGroups, ...availableBlackList]}
                onSelectAvailableItem={add}
                onRemoveItem={exclude}
            />
        </div>
    );
};

PlayerReportTags.defaultProps = {
    userGroups: [],
    playerGroups: [],
};

PlayerReportTags.propTypes = {
    id: PropTypes.number,
    updateGroupData: PropTypes.func.isRequired,
    updateBlackList: PropTypes.func.isRequired,
    player: PropTypes.object.bool,
    isOrganizer: PropTypes.bool,
    userGroups: PropTypes.array,
    playerGroups: PropTypes.array,
    blacklists: PropTypes.array,
    isMobile: PropTypes.bool,
};

export default PlayerReportTags;

const prepareGroups = (arrayOfGroups, id, isBlackList = false) => {
    let appliedGroups = [],
        availableGroups = [];

    arrayOfGroups.forEach((group) => {
        const selectedUser = find(group.players, (player) => player.id === id);
        const isAdded = Boolean(selectedUser);
        if (isAdded) {
            appliedGroups.push({
                value: group.id,
                text: group.name,
                customRender: isBlackList
                    ? (tagFields) => (
                          <Tooltip
                              placement="top"
                              styles={{
                                  popup: { bottom: "calc(100% + 18px)" },
                              }}
                              message={
                                  <div>
                                      <p className="ellipsis">{selectedUser.reason}</p>
                                  </div>
                              }
                          >
                              <Tag {...tagFields} />
                          </Tooltip>
                      )
                    : null,
                type: isBlackList ? "alert" : null,
                isBlackList,
            });
        } else {
            availableGroups.push({
                value: group.id,
                text: group.name,
                isBlackList,
            });
        }
    });

    return [appliedGroups, availableGroups];
};
